import { VStack } from '@chakra-ui/react';
import { useEffect } from 'react';
import PartnerBillingSettings from './accordionSections/PartnerBillingSettings';
import PartnerInvoiceSettings from './accordionSections/PartnerInvoiceSettings';
import PartnerBillingInvoiceFormat from './accordionSections/PartnerBillingInvoiceFormat';
import { usePartnerForm } from '../hooks/usePartnerForm';

// eslint-disable-next-line no-unused-vars
const PartnerBillingInvoice = ({
    darkMode,
    errors,
    touched,
    defaultPlansData,
}) => {
    const { formData } = usePartnerForm();

    useEffect(() => {
        console.log('=== PartnerBillingInvoice Tab ===');
        console.log('formData:', formData);
        console.log(
            'partnerBillingSettings:',
            formData?.partnerBillingSettings,
        );
    }, [formData]);

    const billingState = formData.partnerBillingSettings;

    return (
        <VStack spacing={4} align="stretch">
            <PartnerBillingSettings
                darkMode={darkMode}
                errors={errors}
                touched={touched}
                defaultPlansData={defaultPlansData}
            />
            <PartnerInvoiceSettings
                darkMode={darkMode}
                errors={errors}
                touched={touched}
            />
            <PartnerBillingInvoiceFormat
                darkMode={darkMode}
                errors={errors}
                touched={touched}
                billingState={billingState}
            />
        </VStack>
    );
};

export default PartnerBillingInvoice;
